import React from "react";
import { Route, Switch } from "react-router";
import MainLayout from "../Component/Layout/MainLayout";
import MainPage from "../Component/Pages/MainPage";
import NewsDetails from "../Component/Pages/NewsDetails";
import NewsIndex from "../Component/Pages/NewsIndex";
import Products from "../Component/Pages/Products";
import ScrollToTop from "../utils/ScrollToTop";
import BlogIndex from "../Component/Pages/BlogIndex";
const VionnaWebsite = () => {
  return (
    <MainLayout>
      <ScrollToTop />
      <Switch>
        <Route path="/NewsDetails/:id" render={() => <NewsDetails />} />
        <Route path="/Products/Index" render={() => <Products />} />
        <Route path="/News/Index" render={() => <NewsIndex />} />
        <Route path="/blogs/Index" render={() => <BlogIndex />} />
        <Route path="/" exact render={() => <MainPage />} />
      </Switch>
    </MainLayout>
  );
};

export default VionnaWebsite;
